/**
 * OrbDocTutorialsBeginnerTaskManagerENOrbDocTutorialsBeginnerTaskManagerENPage
 *
 * Page component for OrbDocTutorialsBeginnerTaskManagerENOrbDocTutorialsBeginnerTaskManagerENPage
 * Path: /docs/tutorials/beginner/task-manager
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocTutorialsBeginnerTaskManagerENDocScreenView as __OrbDocTutorialsBeginnerTaskManagerENDocScreenView } from '@/components/traits/OrbDocTutorialsBeginnerTaskManagerENDocScreenView';
import { OrbDocTutorialsBeginnerTaskManagerENDocAnalyticsView as __OrbDocTutorialsBeginnerTaskManagerENDocAnalyticsView } from '@/components/traits/OrbDocTutorialsBeginnerTaskManagerENDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocTutorialsBeginnerTaskManagerENOrbDocTutorialsBeginnerTaskManagerENPageProps {
  // Add any page-level props here
}

export function OrbDocTutorialsBeginnerTaskManagerENOrbDocTutorialsBeginnerTaskManagerENPage(_props: OrbDocTutorialsBeginnerTaskManagerENOrbDocTutorialsBeginnerTaskManagerENPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"Build a task manager","description":"Stored rows, a form that adds one, row actions that complete and delete, and a list that reloads after every write.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/tutorials/beginner/task-manager"},{"locale":"ar","path":"/ar/docs/tutorials/beginner/task-manager"},{"locale":"sl","path":"/sl/docs/tutorials/beginner/task-manager"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocTutorialsBeginnerTaskManagerENDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocTutorialsBeginnerTaskManagerENDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocTutorialsBeginnerTaskManagerENOrbDocTutorialsBeginnerTaskManagerENPage;
